import React, {useCallback, useEffect} from 'react'
import { observer, useLocalObservable } from "mobx-react-lite"
import classes from './Whoops.module.scss'
import { useNavigate } from "@reach/router"
import OutlinedInput from '@mui/material/OutlinedInput';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import LoadingButton from '@mui/lab/LoadingButton';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import clsx from 'clsx'

import Password from '../account/Password'
import userStore from '../common/userStore';

const Whoops = observer(({}) => {
  const inputClasses = {'root':classes.input, 'notchedOutline': classes.notchedOutline}
  const navigate = useNavigate()

  const form = useLocalObservable(() => ({
    password: '',
    error: null,
    immediately: false,
    loading: false,
    setLoading(loading) {
      this.loading = loading
    },
    setError(err) {
      this.error = err
    },
    handlePassword(e) {
      this.password = e.target.value
      this.immediately && this.validPassword()
    },
    validPassword() {
      const rs = this.password.length > 0 // to 8
      this.error = rs ? null : 'Password is required'
      return rs
    },
    handleKeyup(e) {
      if(e.keyCode === 13) {
        this.handleSubmit()
      }
    },
    async handleSubmit() {
      try {
        this.immediately = true
        if (!this.validPassword()) {
          return;
        }
        this.setLoading(true)
        if (userStore.loginBy == 'google') {
          await userStore.mergeByGoogle(this.password)
        }
        else if (userStore.loginBy == 'facebook') {
          await userStore.mergeByFacebook(this.password)
        }
      } catch (e) {
        console.log('merge fail',e) 
        this.setError('Password is invalid')
      } finally {
        this.setLoading(false)
      }
    }
  }))

  const toForgot = useCallback(() => {
    navigate('/auth/forgot-password')
  }, [navigate])

  const onCancel = useCallback(() => {
    userStore.cancelMerge()
    navigate(-1)
  }, [navigate, userStore.cancelMerge])

  useEffect(() => {
    if (userStore.isLogin) {
      navigate('/')
    }
  }, [navigate, userStore.isLogin])

  return <div className={classes.center}>
      <h1>Whoops</h1>
      <div className={classes.tips}>
      An account already exists with the email linked to this account. Please enter the password to that account.
      </div>

      <FormControl className={clsx(classes.field)}>
        <Password classes={inputClasses} 
          name="password"
          size="small" 
          placeholder="Password" 
          onChange={form.handlePassword} 
          onKeyUp={form.handleKeyup} />
      </FormControl>
      {form.error ? <div className={classes.error}>{form.error}</div> : null}

      <Link className={classes.forgot} underline="none" onClick={toForgot}>Forgot password?</Link>

      <div className={classes.actions}>
        <Button variant="outlined" onClick={onCancel}>Cancel</Button>
        <LoadingButton className={classes.submit} variant="contained" disableElevation 
          onClick={form.handleSubmit} loading={form.loading}>OK</LoadingButton>
      </div>

      <div className={classes.footer}>
      Someone else registered with this email? <Link className={classes.forgot} underline="none" href="mailto:support@sessionloops.com">Contact us</Link>
      </div>
    </div>
})

export default Whoops